import { Injectable } from '@angular/core';
import { ApiHttpService } from 'src/app/Service/api.http.service';
import { APIEndPoints } from 'src/app/utils/api-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  constructor(private _apiService: ApiHttpService) {}

  PostContactMassage(body) {
    return this._apiService.post(APIEndPoints.ContactMessage, body).pipe();
  }
}
